export default {
  name: "CenteredTitle",
  props: {
    title: { type: String, default: "" }
  },
  computed: {
  },
  mounted() {
  },
  created: function () {
  },
  components: {
  },
  methods: {
  }
};
